import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Label } from "reactstrap";

const ClientTypeChooser = ({ value, onClientTypeChange }) => {
  const [terceroSelected, setTerceroSelected] = useState(value);
  const setSelectedClass = isSelected =>
    isSelected ? "btn btn-sm btn-toggle active" : "btn btn-sm btn-toggle";
  const emitChange = isTercero =>
    isTercero ? onClientTypeChange("CLIENT") : onClientTypeChange("BIG_ACCOUNT");
  const onClick = () => {
    setTerceroSelected(!terceroSelected);
    emitChange(!terceroSelected);
  };
  return (
    <Row>
      <div className="col-12">
        <h4>Tipo de cuenta</h4>
      </div>
      <div className="col-12 d-flex justify-content-between">
        <Row className="mb-3">
          <div className="col-md-12">
            <Label className="boolean-filter-label" for="terceros">
              Tercero
            </Label>
            <button
              type="button"
              className={setSelectedClass(terceroSelected)}
              data-toggle="button"
              aria-pressed="true"
              autoComplete="off"
              onClick={onClick}
            >
              <div className="handle" />
            </button>
          </div>
        </Row>
        <Row className="mb-3">
          <div className="col-md-12">
            <Label className="boolean-filter-label" for="big-accounts">
              Cuenta mayor
            </Label>
            <button
              type="button"
              className={setSelectedClass(!terceroSelected)}
              data-toggle="button"
              aria-pressed="true"
              autoComplete="off"
              onClick={onClick}
            >
              <div className="handle" />
            </button>
          </div>
        </Row>
      </div>
    </Row>
  );
};

ClientTypeChooser.propTypes = {
  value: PropTypes.bool,
  onClientTypeChange: PropTypes.func
};
ClientTypeChooser.defaultProps = {
  value: true,
  onClientTypeChange: () => {}
};
export default ClientTypeChooser;
